/**
 * @returns true if Hire Me feature is enabled false otherwise.
 */
export function isHireMeEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_HIRE_ME === "true";
}

/**
 * @returns true if Hire Me feature is enabled false otherwise.
 */
export function isCareerMarketplaceEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_CAREER_MARKET === "true";
}
